import React from 'react';
import { DragDropFileUpload } from './DragDropFileUpload';

interface DocumentUploadProps {
  documentType: string; // e.g., "license", "education", "certification"
  onUploadSuccess?: (fileData: any) => void;
  onUploadError?: (error: string) => void;
  acceptTypes?: string;
  maxSizeMB?: number;
  required?: boolean;
  driverId?: number;
}

export const DocumentUpload: React.FC<DocumentUploadProps> = ({
  documentType,
  onUploadSuccess = () => {},
  onUploadError = () => {},
  acceptTypes = 'image/*,.pdf,.doc,.docx',
  maxSizeMB = 10,
  required = false,
  driverId,
}) => {
  const getDocumentTypeLabel = (type: string): string => {
    switch (type.toLowerCase()) {
      case 'license':
        return 'license document';
      case 'education':
        return 'education/training document';
      case 'certification':
        return 'certification document';
      case 'insurance':
        return 'insurance document';
      case 'registration':
        return 'registration document';
      default:
        return 'document';
    }
  };

  return (
    <DragDropFileUpload
      title={`Drag & drop or click to upload ${getDocumentTypeLabel(documentType)}`}
      subtitle={`Choose your ${getDocumentTypeLabel(documentType)} or drag it here`}
      buttonText={`Browse ${documentType.charAt(0).toUpperCase() + documentType.slice(1)} Files`}
      dragText={`Drop ${getDocumentTypeLabel(documentType)} here`}
      dragSubtext="Release to upload your document"
      acceptTypes={acceptTypes}
      maxSizeMB={maxSizeMB}
      required={required}
      folderPath={`drivers/${driverId}/${documentType}`}
      description={`${documentType} document for driver`}
      onUploadSuccess={onUploadSuccess}
      onUploadError={onUploadError}
      height={140}
    />
  );
};
